import React from "react";
import { Link } from 'react-router-dom';
const Footer = () => {




  return (
    <footer className="pt-20 pb-4 he" style={{ backgroundImage: 'url(images/background_pattern.png)' }}>
      <div className="section-shape top-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>


      {/* Footer Upper Section */}
      <div className="footer-upper pb-4">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="footer-about">
                <img src="/images/banner/logo.png" alt="" />
                <p className="mt-3 mb-3 white">
                  Anand Krushi Paryatan Kendra is a peaceful place in Pune started by Mr. Anand Thopate in 1995. He loves nature and wanted to share it with others.</p>
                <ul>
                  <i className="fas fa-phone-alt text-white"></i> <a href="tel:+919689125047" className='d-inline'>+91 9689125047</a><br />
                  <i className="fas fa-phone-alt text-white"></i> <a href="tel:+919623755047" className='d-inline'>+91 9623755047</a><br />
                  <i className="fas fa-phone-alt text-white"></i> <a href="tel:+919673132497" className='d-inline'>+91 9673132497</a><br />
                  <li className="white"><strong>Location:</strong>  Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218</li>
                  <li className="white"><strong>Email:</strong> <a href="mailto:thopatemala@gmail.com">thopatemala@gmail.com</a></li>
                </ul>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-12 col-md-3">
              <div className="footer-links">
                <h3 className="white">services</h3>
                <ul>
<Link className="mx-md-2 d-block" to="/One-Day-Picnic-Spot-Near-Pune-at-Morachi-Chincholi">
  <i className="fas fa-swimmer darkcolor"></i> One day picnic spot near Pune at Morachi Chincholi
</Link>
<Link className="mx-md-2 d-block" to="/Pune-Nearby-Attractions">
  <i className="fas fa-swimmer darkcolor"></i> Pune nearby attractions
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Pune-Nearby-Attractions">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Pune Nearby attractions
</Link>
<Link className="mx-md-2 d-block" to="/Day-Trip-Destinations-Near-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Day trip destinations near Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/Places-to-Visit-Nearby-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Places to visit nearby Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/One-Day-Getaway-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> One-day getaway Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Tourist-Spot-Near-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Tourist spot near Pune
</Link>
<Link className="mx-md-2 d-block" to="/Day-Outing-Place-Anand-Krushi-Paryatan-Kendra-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Day outing place Anand Krushi Paryatan Kendra Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/Anand-Krushi-Paryatan-Kendra-Morachi-Chincholi-Pune-Agro-Tourism">
  <i className="fas fa-swimmer darkcolor"></i> Anand Krushi Paryatan Kendra Morachi Chincholi Pune Agro Tourism
</Link>
<Link className="mx-md-2 d-block" to="/Agro-Tourism-Morachi-Chincholi">
  <i className="fas fa-swimmer darkcolor"></i> Agro Tourism Morachi Chincholi
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Tourist-Attractions-Nearby-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Tourist attractions nearby Pune
</Link>
<Link className="mx-md-2 d-block" to="/Day-Tour-Destinations-Near-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Day tour destinations near Morachi Chincholi Pune
</Link>

<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Pune-Place-to-Explore-Nearby">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Pune Place to explore nearby
</Link>
<Link className="mx-md-2 d-block" to="/Pune-Nearby-Sightseeing-Spot-Morachi-Chincholi">
  <i className="fas fa-swimmer darkcolor"></i> Pune Nearby sightseeing spot Morachi Chincholi
</Link>
<Link className="mx-md-2 d-block" to="/Day-Trip-Ideas-Near-Pune-Morachi-Chincholi-With-Family">
  <i className="fas fa-swimmer darkcolor"></i> Day trip ideas near Pune Morachi Chincholi with Family
</Link>
<Link className="mx-md-2 d-block" to="/Quick-Day-Trip-Destinations-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Quick day trip destinations Morachi Chincholi Pune
</Link>
                




                </ul>
              </div>
            </div>

            {/* Categories */}
            <div className="col-12 col-md-3">
              <div className="footer-links">
                <h3 className="white">services</h3>
                <ul>


                  
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Best-Place-Near-Pune-for-Short-Visit">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Best place near Pune for Short visit
</Link>
<Link className="mx-md-2 d-block" to="/Short-Trip-Destinations-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Short trip destinations Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/Hurda-Party-Morachi-Chincholi">
  <i className="fas fa-swimmer darkcolor"></i> Hurda Party Morachi Chincholi
</Link>
<Link className="mx-md-2 d-block" to="/Mango-Mahotsav-Morachi-Chincholi">
  <i className="fas fa-swimmer darkcolor"></i> Mango Mahostav Morachi Chincholi
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Water-Park">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi water park
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Activities">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Activities
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Home-Stay">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Home stay
</Link>
<Link className="mx-md-2 d-block" to="/Corporate-Outing-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Corporate outing Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/Destination-Wedding-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Destination Wedding Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/Birthday-Party-Hosting-Morachi-Chincholi-Near-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Birthday Party Hosting Morachi Chincholi near Pune
</Link>


<Link className="mx-md-2 d-block" to="/One-Day-School-Picnic-Near-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> One-day School picnic near Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/College-Picnic-Places-at-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> College Picnic places at Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/Corporate-Event-Hosting-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Corporate event Hosting Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/Camping-Place-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Camping Place Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Package">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Package
</Link>
<Link className="mx-md-2 d-block" to="/Resort-Near-Pune-for-Event-Celebration-Morachi-Chincholi">
  <i className="fas fa-swimmer darkcolor"></i> Resort near Pune for event celebration Morachi Chincholi
</Link>
<Link className="mx-md-2 d-block" to="/Family-Get-Together-Morachi-Chincholi-Near-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Family get-together Morachi Chincholi near Pune
</Link>
                </ul>
              </div>
            </div>

            <div className="col-12 col-md-3">
              <div className="footer-links">
                <h3 className="white">services</h3>
                <ul>


<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Resort-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Resort Pune
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Farmhouse-Near-Pune-On-Rent">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Farmhouse near Pune on rent
</Link>
<Link className="mx-md-2 d-block" to="/Pre-Wedding-Shoot-Destination-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Pre wedding shoot destination Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/Adventure-Activities-at-Morachi-Chincholi-Pune">
  <i className="fas fa-swimmer darkcolor"></i> Adventure activities at Morachi Chincholi Pune
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Online-Booking">
  <i className="fas fa-swimmer darkcolor"></i> Morachi chincholi online booking
</Link>
<Link className="mx-md-2 d-block" to="/School-Picnic-Organisers-in-Pune">
  <i className="fas fa-swimmer darkcolor"></i> School Picnic Organisers in Pune
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-School-Picnic">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi School Picnic
</Link>
<Link className="mx-md-2 d-block" to="/School-Picnic-Organisers-in-Pimpri-Chinchwad">
  <i className="fas fa-swimmer darkcolor"></i> School Picnic Organisers in Pimpri Chinchwad
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-School-Picnic-Spot">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi School Picnic Spot
</Link>
<Link className="mx-md-2 d-block" to="/One-Day-School-Picnic-Spot-Near-Pune">
  <i className="fas fa-swimmer darkcolor"></i> One Day School Picnic Spot Near Pune
</Link>
<Link className="mx-md-2 d-block" to="/One-Day-School-Picnic-Spot-Near-Pune-Within-100-Kms">
  <i className="fas fa-swimmer darkcolor"></i> One day school picnic spot near pune within 100 kms
</Link>
<Link className="mx-md-2 d-block" to="/One-Day-School-Picnic-Spot-Near-Pune-Within-50-Kms">
  <i className="fas fa-swimmer darkcolor"></i> One day school picnic spot near pune within 50 kms
</Link>
<Link className="mx-md-2 d-block" to="/Ranjangaon-Ganpati-Nighoj-Kund-Morachi-Chincholi-School-Picnic">
  <i className="fas fa-swimmer darkcolor"></i> Ranjangaon Ganpati - Nighoj Kund - Morachi Chincholi School Picnic
</Link>
<Link className="mx-md-2 d-block" to="/School-Picnic-Spots-Near-Pune-for-Students-Classes">
  <i className="fas fa-swimmer darkcolor"></i> School Picnic Spots Near Pune for Students Classes
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Water-Park-Online-Booking">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Water Park Online Booking
</Link>
<Link className="mx-md-2 d-block" to="/Morachi-Chincholi-Tour-Package">
  <i className="fas fa-swimmer darkcolor"></i> Morachi Chincholi Tour Package
</Link>

                </ul>
              </div>
            </div>

            {/* Newsletter */}

          </div>
        </div>
      </div>

      

      {/* Footer Copyright Section */}
      <div className="footer-copyright">
        <div className="container">
          <div className="copyright-inner rounded p-3 d-md-flex align-items-center justify-content-between">
            <div className="copyright-text">
              <p className="text-white text-center">
                All Rights Reserved @ <span className="darkcolor">Anand Krushi Paryatan Kendra</span> 2025 Developed By
                <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                  <span className="darkcolor">&nbsp;Dexter Intelligence</span>
                </a> | Hosted By
                <a href="https://www.urvahosting.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                  <span className="darkcolor">&nbsp;Urva Hosting</span>
                </a>
              </p>
            </div>
            <div className="social-links">
              <ul>
                <li><a href="#"><i className="fab fa-facebook" aria-hidden="true"></i></a></li>
                <li><a href="#"><i className="fab fa-twitter" aria-hidden="true"></i></a></li>
                <li><a href="#"><i className="fab fa-instagram" aria-hidden="true"></i></a></li>
                <li><a href="#"><i className="fab fa-linkedin" aria-hidden="true"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div id="particles-js"></div>
    </footer>
  );
};

export default Footer;
